import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import markerCss from '../Marker.module.css';
import {getGymIcon} from "../../../utils";
import Label from "../Label";
import css from './GymMarker.module.css';
import WatchLaterIcon from '@material-ui/icons/WatchLater';

const GymMarker = (props) => {
	let height=44;
	let width=44;
	const classes = [];

	const time = (new Date()).getTime() / 1000;
	let secsTillEnd = props.gym.end - time;
	let secsTillStart = props.gym.start - time;

	let imgStyle = {};
	if( props.gym.start && secsTillStart <= 0 && secsTillEnd > 0 ) { // If active raid
		imgStyle = {filter: 'saturate(10%)'};
		if( props.gym.team_id === 2 )
			imgStyle = {filter: 'saturate(10%)'};
		else if( props.gym.team_id === 3 )
			imgStyle = {filter: 'saturate(10%)'};
	}

	const getLabel = () => {
		const lines = [];
		if( props.zoom >= 16 )
			lines.push(<div  key={'gymname-' + props.gym.gym_id} className={css.GymNameLabel}>{props.gym.name}</div>);

		if( props.gym.start ) {
			// if( secsTillStart <= 0 && props.showRaids )
			// 	return null;

			// if( props.gym.pokemon_id )
			// 	lines.push(<div>Raid for {Math.floor(secsTillEnd / 60)}m</div>);
			if( secsTillStart > 0 ) {
				lines.push(<div key={'gymraidin-' + props.gym.gym_id}>Raid in {Math.floor(secsTillStart / 60)}m</div>);
				classes.push(css.RaidLabelUpcoming);
			} else if (secsTillEnd > 0 ) {
				lines.push(<div key={'gymraidfor-' + props.gym.gym_id}>Raid	for {Math.floor(secsTillEnd / 60)}m</div>);
				classes.push(css.RaidLabelActive);
			}
		}
		return lines.length ? <Label text={lines} classes={classes} /> : null;
	};

	let badge = null;
	if( props.badges && props.badges[props.gym.gym_id] > 1 ) {
		const colors = ['', '', '#cd7f32', '#eeeeee', '#ffd700'];
		badge = (<svg className={css.MarkerBadge} height="15" width="15">
			<circle cx="7" cy="7" r="5" stroke='#666' strokeWidth="1" fill={colors[props.badges[props.gym.gym_id]]} />
		</svg>);
	}

	const label = getLabel();

	const stale = props.gym.is_stale && props.isAdmin ? <WatchLaterIcon className={css.StaleIcon} /> : null;

	return (<>
		{props.infoWindow}
		<div className={markerCss.Marker}>
			<div onClick={() => props.onClick(props.gym)}>
				<img alt={props.gym.name} src={getGymIcon(props.gym, props.isAdmin)} height={height} width={width} style={imgStyle} />
				{badge}
				{stale}
			</div>
			{label}
		</div>
	</>);
};

GymMarker.propTypes = {
	gym: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
	return {
		showRaids: state.filter.showRaids,
		badges: state.core.badges,
		zoom: state.map.zoom,
		isAdmin: state.core.isAdmin,
	};
};


export default connect(mapStateToProps)(GymMarker);